import { NAVBAR_REVAMP_PREFIX as FEATURE_PREFIX } from 'featurePrefix.ids'

const ACCOUNTS_PREFIX = 'accounts'
const RETAILER_ACCOUNTS_PREFIX = 'retailer_accounts'
const CART_PREFIX = 'cart'
const CONNECTIONS_PREFIX = 'connections'
const DISCOVER_PREFIX = 'discover'
const DROPDOWN_OPTION_PREFIX = 'dropdown-option'
const EXPLORE_PREFIX = 'explore'
const HAMBURGER_PREFIX = 'hamburger'
const SUBMISSIONS_PREFIX = 'submissions'
const HOME_PREFIX = 'home'
const PRO_LITE_INDICATOR_PREFIX = 'pro-lite-indicator'
const LANGUAGES_PREFIX = 'languages'
const MESSAGES_PREFIX = 'messages'
const ORDERS_PREFIX = 'orders'
const PASSPORT_PREFIX = 'passport'
const PAYMENTS_PREFIX = 'payments'
const PRODUCTS_PREFIX = 'products'
const PROFILE_PREFIX = 'profile'
const REPORTING_PREFIX = 'reporting'
const REPORTS_PREFIX = 'reports'
const SETTINGS_PREFIX = 'settings'
const SHOP_PREFIX = 'shop'
const TRIGGER_PREFIX = 'trigger'
const WORKSPACES_PREFIX = 'workspaces'

export const OrdersDropdownIds = {
  OrdersTrigger: `${FEATURE_PREFIX}__${ORDERS_PREFIX}__${TRIGGER_PREFIX}`,
  OrdersAndVisualAssortmentTrigger: `${FEATURE_PREFIX}__${ORDERS_PREFIX}__${TRIGGER_PREFIX}__and-visual-assortment`,
  OrdersOptionOrders: `${FEATURE_PREFIX}__${ORDERS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__orders`,
  OrdersOptionStartOrder: `${FEATURE_PREFIX}__${ORDERS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__start-orders`,
  OrdersOptionImportOrders: `${FEATURE_PREFIX}__${ORDERS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__import-orders`,
  OrdersProFeature: `${FEATURE_PREFIX}__${ORDERS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__pro-feature`,
  OrdersProFeatureLearnMore: `${FEATURE_PREFIX}__${ORDERS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__pro-feature-learn`,
  OrdersOptionVisualAssortment: `${FEATURE_PREFIX}__${ORDERS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__visual-assortment`,
} as const

export const PaymentsDropdownIds = {
  PaymentTrigger: `${FEATURE_PREFIX}__${PAYMENTS_PREFIX}__${TRIGGER_PREFIX}`,
  PaymentsOptionsManageJoorPayOrders: `${FEATURE_PREFIX}__${PAYMENTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__manage_joor_pay_orders`,
  PaymentsOptionsExternalPayments: `${FEATURE_PREFIX}__${PAYMENTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__external_payments`,
  PaymentsOptionsJOORPayButton: `${FEATURE_PREFIX}__${PAYMENTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__joor_pay__button`,
  PaymentsOptionsJOORPayPromo: `${FEATURE_PREFIX}__${PAYMENTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__joor_pay_text`,
}

export const ConnectionsDropdownIds = {
  ConnectionIconTrigger: `${FEATURE_PREFIX}__${CONNECTIONS_PREFIX}__${TRIGGER_PREFIX}__icon`,
  ConnectionOptionsFindRetailers: `${FEATURE_PREFIX}__${CONNECTIONS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__find_retailers`,
  Prospects: `${FEATURE_PREFIX}__${CONNECTIONS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__prospects`,
  ConnectionOptionsManage: `${FEATURE_PREFIX}__${CONNECTIONS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__manage`,
  ConnectionOptionsMyConnections: `${FEATURE_PREFIX}__${CONNECTIONS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__my_connections`,
  ConnectionOptionsRequests: `${FEATURE_PREFIX}__${CONNECTIONS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__requests`,
  ConnectionOptionsPending: `${FEATURE_PREFIX}__${CONNECTIONS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__pending_connections`,
  ConnectionTrigger: `${FEATURE_PREFIX}__${CONNECTIONS_PREFIX}__${TRIGGER_PREFIX}`,
}
export const ProductsDropdownIds = {
  ProductsTrigger: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${TRIGGER_PREFIX}`,
  ProductsOptionsCreateLinesheet: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__create-linesheet`,
  ProductsOptionsColorSwatches: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__color-swatches`,
  ProductsOptionsCreateLook: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__create-look`,
  ProductsOptionsCreateStyle: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__create-style`,
  ProductsOptionsCreateStyleboard: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__create-styleboard`,
  ProductsOptionsInventory: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__inventory`,
  ProductsOptionsManageLinesheets: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__manage-linesheets`,
  ProductsOptionsManageLooks: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__manage-looks`,
  ProductsOptionsManageStaging: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__staging`,
  ProductsOptionsManageStyleSync: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__style-sync`,
  ProductsOptionsManageStyleboards: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__manage-styleboards`,
  ProductsOptionsManageStyles: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__manage-styles`,
  ProductsOptionsUploadData: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__upload-data`,
  ProductsOptionsUploadImages: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__upload-images`,
  ProductsOptionsBasicStyleUploader: `${FEATURE_PREFIX}__${PRODUCTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__basic-style-uploader`,
}
export const ProfileDropdownIds = {
  ProfileOptionsAboutAssets: `${FEATURE_PREFIX}__${PROFILE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__about_assets`,
  ProfileOptionsLookbooks: `${FEATURE_PREFIX}__${PROFILE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__lookbooks`,
  ProfileOptionsManage: `${FEATURE_PREFIX}__${PROFILE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__manage`,
  ProfileOptionsview: `${FEATURE_PREFIX}__${PROFILE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__view`,
  ProfileOptionsPhotoGallery: `${FEATURE_PREFIX}__${PROFILE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__photo_gallery`,
  ProfileOptionsPress: `${FEATURE_PREFIX}__${PROFILE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__press`,
  ProfileOptionsViews: `${FEATURE_PREFIX}__${PROFILE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__profile_views`,
  ProfileTrigger: `${FEATURE_PREFIX}__${PROFILE_PREFIX}__${TRIGGER_PREFIX}`,
}

export const ReportsDropdownIds = {
  ReportsTrigger: `${FEATURE_PREFIX}__${REPORTS_PREFIX}__${TRIGGER_PREFIX}`,
  ReportsOptionSalesSummary: `${FEATURE_PREFIX}__${REPORTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__sales_summary`,
  ReportsOptionDelivery: `${FEATURE_PREFIX}__${REPORTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__delivery_report`,
  ReportsOptionStyleDetail: `${FEATURE_PREFIX}__${REPORTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__style_detail`,
  ReportsOptionProductionReport: `${FEATURE_PREFIX}__${REPORTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__production_report`,
  ReportsOptionCustomReports: `${FEATURE_PREFIX}__${REPORTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__custom_reports`,
  ReportsOptionClassicReports: `${FEATURE_PREFIX}__${REPORTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__classic_reports`,
  ReportsOptionShippingReport: `${FEATURE_PREFIX}__${REPORTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__shipping_report`,
  ReportsOptionProFeature: `${FEATURE_PREFIX}__${ORDERS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__pro-feature`,
  ReportsOptionProFeatureLearnMore: `${FEATURE_PREFIX}__${ORDERS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__pro-feature-learn`,
}
export const AccountsDropdownIds = {
  AccountsTrigger: `${FEATURE_PREFIX}__${ACCOUNTS_PREFIX}__${TRIGGER_PREFIX}`,
  AccountsOption: `${FEATURE_PREFIX}__${ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}`,
  AccountsSearchBar: `${FEATURE_PREFIX}__${ACCOUNTS_PREFIX}__search-bar`,
}

export const RetailAccountsDropdownIds = {
  AccountsTrigger: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${TRIGGER_PREFIX}`,
  AccountsSearchBar: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__search-bar`,
  Language: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__language`,
  Logo: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${TRIGGER_PREFIX}__logo`,
  EmptyLogo: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${TRIGGER_PREFIX}__empty-logo`,
  PrimaryAccountCheckbox: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__check-primary-account`,
  CurrentAccount: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__current_account`,
  OtherAccounts: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__other_accounts`,
  AccountSettings: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__my_settings`,
  SSO: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}_sso`,
  ManageProfile: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__manage`,
  AccountsOption: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}`,
  SwitchTo: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__switch_to`,
  Logout: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__logout`,
  Help: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__help_center`,
  VisbilityModal: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__accounts-privacy-modal`,
  RecentAccountsModal: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__recent-accounts-modal`,
  DataActivityCenterPage: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__data-activity-center`,
  PremiumFeatures: `${FEATURE_PREFIX}__${RETAILER_ACCOUNTS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__premium_features`,
}

export const LanguagesDropdownIds = {
  LanguagesTrigger: `${FEATURE_PREFIX}__${LANGUAGES_PREFIX}__${TRIGGER_PREFIX}`,
  LanguagesOptions: `${FEATURE_PREFIX}__${LANGUAGES_PREFIX}__${DROPDOWN_OPTION_PREFIX}`,
}

export const CartDropdownIds = {
  CartBadge: `${FEATURE_PREFIX}__${CART_PREFIX}__badge`,
  CartTrigger: `${FEATURE_PREFIX}__${CART_PREFIX}__${TRIGGER_PREFIX}`,
  CartView: `${FEATURE_PREFIX}__${CART_PREFIX}__view`,
  CartContainer: `${FEATURE_PREFIX}__${CART_PREFIX}__container`,
  CartPreview: `${FEATURE_PREFIX}__${CART_PREFIX}__cart_preview`,
  AllocationReportLink: `${FEATURE_PREFIX}__${CART_PREFIX}__allocation_report_link`,
  BudgetReportLink: `${FEATURE_PREFIX}__${CART_PREFIX}__budget_report_link`,
  OrderReviewLink: `${FEATURE_PREFIX}__${CART_PREFIX}__order_review_link`,
  DisplayName: `${FEATURE_PREFIX}__${CART_PREFIX}__display_name`,
  ViewCart: `${FEATURE_PREFIX}__${CART_PREFIX}__view_cart`,
}
export const DiscoverDropdownIds = {
  DiscoverTrigger: `${FEATURE_PREFIX}__${DISCOVER_PREFIX}__${TRIGGER_PREFIX}`,
  DiscoverOptionFindNewBrands: `${FEATURE_PREFIX}__${DISCOVER_PREFIX}__${DROPDOWN_OPTION_PREFIX}__find_new_brands`,
  DiscoverOptionPassport: `${FEATURE_PREFIX}__${DISCOVER_PREFIX}__${DROPDOWN_OPTION_PREFIX}__passport`,
}

export const ExploreDropdownIds = {
  ExploreTrigger: `${FEATURE_PREFIX}__${EXPLORE_PREFIX}__${TRIGGER_PREFIX}`,
  ConnectedBrands: `${FEATURE_PREFIX}__${EXPLORE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__connected_brands`,
  ConnectionRequestsReceived: `${FEATURE_PREFIX}__${EXPLORE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__requests_received`,
  ConnectionRequestsSent: `${FEATURE_PREFIX}__${EXPLORE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__requests_sent`,
  FindNewBrands: `${FEATURE_PREFIX}__${EXPLORE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__find_new_brands`,
  InterestedInYou: `${FEATURE_PREFIX}__${EXPLORE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__interested_in_you`,
  Passport: `${FEATURE_PREFIX}__${EXPLORE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__passport`,
  Favorites: `${FEATURE_PREFIX}__${EXPLORE_PREFIX}__${DROPDOWN_OPTION_PREFIX}__favorites`,
}

export const SettingsDropdownIds = {
  SettingsOptionAttributeSettings: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__attribute_settings`,
  SettingsOptionHelp: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__help_center`,
  SettingsOptionIntegrations: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__integrations`,
  SettingsOptionInventory: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__inventory`,
  SettingsOptionKellwood: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__Kellwood`,
  SettingsOptionLogout: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__logout`,
  SettingsOptionMySettings: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__my_settings`,
  SettingsOptionOrderSettings: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__order_settings`,
  SettingsOptionPayment: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__payment_settings`,
  SettingsOptionPermissions: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__permission_settings`,
  SettingsOptionRLM: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__RLM`,
  SettingsOptionRetailerSettings: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__retailer_settings`,
  SettingsOptionShopify: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__shopify_integration`,
  SettingsOptionSSO: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}_sso`,
  SettingsOptionStyleSettings: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__style_settings`,
  SettingsOptionStyleSync: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__style_sync`,
  SettingsOptionSwitchTo: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__switch_to`,
  SettingsOptionPremiumFeatures: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__premium_features`,
  SettingsOptionThirdParty: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__third_party`,
  SettingsOptionUserManagement: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${DROPDOWN_OPTION_PREFIX}__user-management`,
  SettingsTrigger: `${FEATURE_PREFIX}__${SETTINGS_PREFIX}__${TRIGGER_PREFIX}`,
}
export const MessagesOptionIds = {
  MessagesTrigger: `${FEATURE_PREFIX}__${MESSAGES_PREFIX}__${TRIGGER_PREFIX}`,
  MessagesChatIcon: `${FEATURE_PREFIX}__${MESSAGES_PREFIX}__${TRIGGER_PREFIX}__chat-icon`,
}
export const PassportOptionIds = {
  PassportTrigger: `${FEATURE_PREFIX}__${PASSPORT_PREFIX}__${TRIGGER_PREFIX}`,
}
export const HamburgerOptionIds = {
  HamburgerTrigger: `${FEATURE_PREFIX}__${HAMBURGER_PREFIX}__${TRIGGER_PREFIX}`,
}

export const SubmissionsListIds = {
  InterestedInYouButton: `${FEATURE_PREFIX}__${SUBMISSIONS_PREFIX}__interested-in-you-button`,
} as const

export const ShopDropdownIds = {
  ShopTrigger: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${TRIGGER_PREFIX}`,
  ShopOptionLooks: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__looks`,
  ShopOptionBrowseCatalog: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__browse_catalog`,
  ShopOptionCreateStyleboard: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__create_styleboard`,
  ShopOptionStyleBoards: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__styleboards`,
  ShopOptionLinesheets: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__linesheets`,
  ShopOptionStartOrder: `${FEATURE_PREFIX}__${SHOP_PREFIX}__${DROPDOWN_OPTION_PREFIX}__start_order`,
}

export const HomeIds = {
  HomeLinkTrigger: `${FEATURE_PREFIX}__${HOME_PREFIX}__${TRIGGER_PREFIX}`,
}

export const GeneralIds = {
  ShopifyTrigger: `${FEATURE_PREFIX}__shopify_integration__${TRIGGER_PREFIX}`,
}

export const ProLiteIndicatorIds = {
  ProLiteIndicatorText: `${FEATURE_PREFIX}__${PRO_LITE_INDICATOR_PREFIX}__text`,
}

export const WorkspacesOptionIds = {
  WorkspacesTrigger: `${FEATURE_PREFIX}__${WORKSPACES_PREFIX}__${TRIGGER_PREFIX}`,
  WorkspacesOption: `${FEATURE_PREFIX}__${WORKSPACES_PREFIX}__${DROPDOWN_OPTION_PREFIX}__workspaces`,
  BrandNotesOption: `${FEATURE_PREFIX}__${WORKSPACES_PREFIX}__${DROPDOWN_OPTION_PREFIX}__brand_notes`,
  ArchivedOption: `${FEATURE_PREFIX}__${WORKSPACES_PREFIX}__${DROPDOWN_OPTION_PREFIX}__archived`,
}

export const ReportingOptionIds = {
  ReportingTrigger: `${FEATURE_PREFIX}__${REPORTING_PREFIX}__${TRIGGER_PREFIX}`,
}
